module.exports = __webpack_public_path__ + "img/GRT橫.fa8c1f7d.jpg";